module.exports = __webpack_public_path__ + "img/reward.bb8de4a2.svg";